import React from 'react';

import TestimonialCard from '@core/components/contentparser/sections/Testimonials/TestimonialCard/TestimonialCard';
import ScrollAnimation from 'react-animate-on-scroll';
import TrustPilot from '@core/components/contentparser/sections/Testimonials/trustpilot/TrustPilot';
import ActionButton from '@core/components/actionbutton/ActionButton';
import UserReviewStars from '@core/components/userreviewstars/UserReviewStars';
import VideoTestimonials from '@core/components/videotestimonials/VideoTestimonials';

import classes from './Testimonials.module.scss';





const Testimonials = ({ section }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleLoadMore = () => {
        setExpanded(true);
    };

    return (
        <>
            <div className='container' style={{ position: 'relative' }}>
                <div
                    className={classes['wrapper']}
                    style={{
                        padding: '0 20px',
                        maxHeight: expanded ? 'none' : '700px',
                        overflowY: expanded ? 'visible' : 'hidden',
                        transition: 'max-height 1s ease',
                        position: 'relative'
                    }}
                >
                    <ScrollAnimation animateIn="fadeInUp" duration={1}>
                        <div className='d-flex justify-content-between mb-3'>
                            <div>
                                <h3>How professionals are achieving their <span>goals</span></h3>
                                <p>
                                    Get started now on your learning journey with a set of courses that cover essential business skills.
                                </p>
                            </div>
                            {/* <TrustPilot /> */}
                            <div className='d-none d-lg-block'>
                                <UserReviewStars />
                            </div>
                        </div>
                    </ScrollAnimation>
                    <div className="row d-none d-xl-flex">
                        <div className="col-xl-4 ">
                            <TestimonialCard data={section.results[0]} />
                            <TestimonialCard data={section.results[3]} />
                            <TestimonialCard data={section.results[6]} />
                        </div>
                        <div className="col-xl-4 ">
                            <TestimonialCard data={section.results[1]} />
                            <TestimonialCard data={section.results[4]} />
                            <TestimonialCard data={section.results[7]} />
                        </div>
                        <div className="col-xl-4 ">
                            <TestimonialCard data={section.results[2]} />
                            <TestimonialCard data={section.results[5]} />
                            <TestimonialCard data={section.results[8]} />
                        </div>
                    </div>
                    <div className="row d-none d-lg-flex d-xl-none">
                        <div className="col-lg-6 ">
                            <TestimonialCard data={section.results[0]} />
                            <TestimonialCard data={section.results[2]} />
                            <TestimonialCard data={section.results[4]} />
                            <TestimonialCard data={section.results[6]} />
                            <TestimonialCard data={section.results[8]} />
                        </div>
                        <div className="col-lg-6 ">
                            <TestimonialCard data={section.results[1]} />
                            <TestimonialCard data={section.results[3]} />
                            <TestimonialCard data={section.results[5]} />
                            <TestimonialCard data={section.results[7]} />
                        </div>
                    </div>
                    <div className="row d-flex d-lg-none">
                        <div className="col-lg-12">
                            <TestimonialCard data={section.results[0]} />
                            <TestimonialCard data={section.results[1]} />
                            <TestimonialCard data={section.results[2]} />
                        </div>
                    </div>
                    {!expanded && (
                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                bottom: 0,
                                height: '200px',
                                background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 100%)',
                                pointerEvents: 'none',
                                transition: 'opacity 0.5s',
                                zIndex: 2
                            }}
                        />
                    )}
                </div>
                {!expanded && (
                    <div className={classes['button-wrapper']}>
                        <ActionButton kind='secondary' onClick={handleLoadMore}>
                            Load More
                        </ActionButton>
                    </div>
                )}
            </div>
            <VideoTestimonials />
        </>
    );
};

export default Testimonials;